const getAllDrawerElements = document.querySelectorAll(
  "quick-buy-drawer[teleport-data]"
);
const getAllPopoverElements = document.querySelectorAll(
  "quick-buy-popover[teleport-data]"
);

const getAllTeleportElements = [
  ...getAllDrawerElements,
  ...getAllPopoverElements,
];

getAllTeleportElements.forEach((element) => {
  const sectioniId = element.getAttribute("teleport-id");
  const target = document.getElementById(sectioniId);

  if (target) {
    target.appendChild(element);
  }
});
